import Helper from '@ember/component/helper';
import { getOwner } from './get-owner';
import { assertExists } from './types/util';
/** Checks if a component with the provided name exists. */
export default class IsComponent extends Helper {
  compute([name]) {
    const owner = assertExists(getOwner(this), 'Could not find owner');
    return Boolean(owner.factoryFor(`component:${name}`));
  }
}